const itp = {
  key: "itp",
  title: "ITP",
  angle: 220,
  summary: "Standardize inspection and test plans integrated with 3D-models.",
  releaseDate: "Late 2027",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: false,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Nov 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Initial data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Sep 27",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Dec 27",
    },
  ],
  points: [
    "Predefined checklists mapped to objects and assets",
    "Administration hub to manage checklists",
    "Automated ITP creation",
    "Direct integration between ITP and 3D-model",
  ],
};

export default itp;
